/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Document_Replacement_In_ProgressInputs */

const es_co2_error_document_replacement_in_progress = /** @type {(inputs: Error_Document_Replacement_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya hay un reemplazo de este documento en proceso.`)
};

/**

* @param {Error_Document_Replacement_In_ProgressInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_document_replacement_in_progress = /** @type {((inputs?: Error_Document_Replacement_In_ProgressInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Document_Replacement_In_ProgressInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_document_replacement_in_progress(inputs)
});